export default __webpack_public_path__ + "static/media/sun.5f4a8e48.svg";